<template>
    <div class="main">
        <table class="table">
            <thead>
                <tr>
                    <th>Filename</th>
                    <th>Uploaded</th>
                    <th>Uploaded By</th>
                    <th>Started processing</th>
                    <th>Finished processing</th>
                    <th>Number of items</th>
                    <th>Total Amount</th>
                    <th>...</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(itm, idx) in files">
                    <tr :key="'filerow_' + idx">
                        <td><a href="#">{{itm.filename}}</a></td>
                        <td>
                            {{itm.uploaded | datetime}}
                        </td>
                        <td>{{itm.uploadedBy}}</td>
                        <td>{{itm.startedProcessing}}</td>
                        <td>{{itm.finishedProcessing}}</td>
                        <td>{{itm.itemCount}}</td>
                        <td>{{itm.itemTotalGross}}</td>
                        <td v-if="isProcessing(itm)">Processing...</td>
                        <td v-else-if="isFinished(itm)"><router-link :to="`/finance/supplierpayments/reconciliation/${itm.id}`">View</router-link></td>
                        <td v-else>Queued...</td>
                    </tr>
                    <tr v-if="itm.batches && itm.batches.length > 0">
                        <td>&nbsp;</td>
                        <td colspan="6">
                            <table class="table">
                                <thead>
                                <th>Batch Number</th>
                                <th>Number of items</th>
                                <th>Total Amount</th>
                                <th>Status</th>
                                <th>...</th>
                                </thead>
                                <tbody>
                                    <tr v-for="(subItm,subIdx) in itm.batches">
                                        <td>{{subItm.batchNumber}}</td>
                                        <td>{{subItm.batchedItems}}</td>
                                        <td>{{subItm.batchTotalGross}}</td>
                                        <td><span :class="batchStatusKlass(subItm)">{{getBatchStatusText(subItm)}}</span></td>
                                        <td>
                                            <a href="#" @click="downloadBatchCSV(subItm.id)">Download</a><span> / </span>
                                            <b-dropdown :disabled="isBatchStatusPaid(subItm)" :id="`markaspaid_${subItm.id}`" :ref="`markaspaid_${subItm.id}`" 
                                                        text="Mark as Paid" size="sm" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'"
                                                        @hidden="reset">
                                                <b-dropdown-form>
                                                    <b-form-group label="Invoice" label-for="`markaspaid_${subItm.id}_invoice`" @submit.stop.prevent>
                                                        <b-form-input :id="`markaspaid_${subItm.id}_invoice`"
                                                                      size="sm" v-model="payload.invoiceNumber" :state="payload.state.invoiceNumber" invalid-feedback="Please enter an invoice number."></b-form-input>
                                                        <b-form-invalid-feedback>
                                                            Please enter an invoice number.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>

                                                    <b-form-group label="Amount" label-for="`markaspaid_${subItm.id}_amount`" @submit.stop.prevent>
                                                        <b-form-input :id="`markaspaid_${subItm.id}_amount`"
                                                                      size="sm" v-model="payload.amount" :state="payload.state.amount" invalid-feedback="The amount entered must match the batch total."></b-form-input>
                                                        <b-form-invalid-feedback>
                                                            The amount entered must match the <br />batch total.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>

                                                    <b-form-group label="Reference" label-for="`markaspaid_${subItm.id}_reference`">
                                                        <b-form-input :id="`markaspaid_${subItm.id}_reference`"
                                                                      size="sm" v-model="payload.paymentReference" :state="payload.state.paymentReference" invalid-feedback="Please enter a payment reference."></b-form-input>
                                                        <b-form-invalid-feedback>
                                                            Please enter a payment reference.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>

                                                    <b-button variant="primary" size="sm" @click="setBatchToPaid(`markaspaid_${subItm.id}`, subItm.id)">Paid</b-button>
                                                </b-dropdown-form>
                                            </b-dropdown>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                        <td><b>Total Amount:</b></td>
                                        <td>{{itm.batchesTotalGross}}</td>
                                        <td>&nbsp;</td>
                                        <td><a href="#" @click="downloadBatchesCSV(itm.id)">Download All</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                        <td>&nbsp;</td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>
<script>
    import { supplierPaymentsService } from "@/services/suplpayments-api.service";
    import { mapActions, mapGetters } from "vuex";
    export default {
        props: {
            files: {type:Array,required:false,default: () => []}
        },
        data: () => {
            return {
                payload: {
                    batchId: null,
                    invoiceNumber: null,
                    amount: null,
                    paymentReference: null,
                    state: {
                        invoiceNumber: null,
                        amount: null,
                        paymentReference: null
                    }
                }
            }
        },
        methods: {
            ...mapActions({
                setBatchStatusPaid: "suplPayments/setBatchStatus"
            }),
            isProcessing(itm) {
                if (itm && itm.startedProcessing) {
                    if (itm.finishedProcessing)
                        return false
                    return true
                }
                return false
            },
            isFinished(itm) {
                if (itm && itm.finishedProcessing) {
                    return true
                }
                return false
            },
            async downloadBatchesCSV(fileId) {
                await supplierPaymentsService.downloadBatchesForFile(fileId)
            },
            async downloadBatchCSV(batchId) {
                await supplierPaymentsService.downloadBatch(batchId)
            },
            async setBatchToPaid(source, batchId) {

                if (!this.payload.invoiceNumber) {
                    this.payload.state.invoiceNumber = false
                } else {
                    this.payload.state.invoiceNumber = true
                }

                if (!this.payload.amount || !this.amountsMatch(this.getBatchAmount(batchId),this.payload.amount)) {
                    this.payload.state.amount = false
                } else {
                    this.payload.state.amount = true
                }

                if (!this.payload.paymentReference) {
                    this.payload.state.paymentReference = false
                } else {
                    this.payload.state.paymentReference = true
                }

                if (!Object.values(this.payload.state).every(v => v === true))
                    return 

                this.$refs[source][0].hide(true)
                
                let { invoiceNumber, amount, paymentReference } = this.payload
                //let { }
                this.reset()

                const payloadEx = {
                    batchId,
                    invoiceNumber,
                    paymentReference,
                    amount
                }
                this.setBatchStatusPaid(payloadEx).finally(() => {
                    console.log('-finally!')
                })
            },
            getBatchStatus(batch) {

                const getMostRecentItem = (arr, dateKey) => {
                    if (!Array.isArray(arr) || arr.length === 0) {
                        return null;
                    }

                    const sorted = [...arr].sort((a, b) => {
                        const dateA = new Date(a[dateKey]);
                        const dateB = new Date(b[dateKey]);

                        if (isNaN(dateA) || isNaN(dateB)) {
                            throw new Error(`Invalid date format in property "${dateKey}"`);
                        }

                        return dateB - dateA;
                    });

                    return sorted[0];
                }


                if (batch && Array.isArray(batch.status) || batch.status.length > 0) {
                    const mostRecent = getMostRecentItem(batch.status, "dateCreated");
                    if (mostRecent)
                        return mostRecent
                }
                return null
            },
            isBatchStatusPaid(batch) {
                const status = this.getBatchStatus(batch)
                //console.log('-status: ', status)
                if (status && status.statusTypeId == 1004)
                    return true

                return false
            },
            getBatchStatusText(batch) {
                const status = this.getBatchStatus(batch)
                if (status) {
                    return status.stateText
                } else {
                    return 'Created'
                }
            },
            batchStatusKlass(batch) {
                const status = this.getBatchStatus(batch)
                if (status) {

                    //if (itm.batchNumber) {
                    //    return 'badge bg-secondary text-white'
                    //}

                    if (status.stateText == 'Paid') {
                        return 'badge bg-success text-white'
                    }
                    else if (itm.status == 'Rejected') {
                        return 'badge bg-danger text-white'
                    } else {
                        return 'badge bg-warning text-white'
                    }
                }
            },
            getBatchAmount(id) {
                for (const file of this.files) {
                    const batch = file.batches.find(b => b.id === id);
                    if (batch) return batch.batchTotalGross;
                }
                return undefined;
            },
            amountsMatch(batchAmount, userAmount) {
                const normalizedBatch = parseFloat(
                    batchAmount.replace(/[^0-9.-]/g, "") // remove £ and commas
                );

                const normalizedUser = parseFloat(
                    userAmount.replace(/[^0-9.-]/g, "") // remove £ and commas
                );
                
                // Compare with a small tolerance to avoid floating‑point issues
                return Math.abs(normalizedBatch - normalizedUser) < 0.0001;
            },
            reset() {
                console.log('-reset')
                this.payload = {
                    batchId: null,
                    invoiceNumber: null,
                    amount: null,
                    paymentReference: null,
                    state: {
                        invoiceNumber: null,
                        amount: null,
                        paymentReference: null
                    }
                }
            }
        }
    }
</script>
